import React from 'react';
import AText from 'antd-mobile/lib/text';



export default class Text extends AText {}